<ng-container *ngIf="_thumbnailUrl">
  @switch (type) {
    @case ('youtube') {
      <img
        [ngSrc]="_thumbnailUrl"
        alt="YouTube Thumbnail"
        [width]="_width"
        [height]="_height"
        (load)="loaded()"
      />
    }
    @case ('vimeo') {
      <img
        alt="Vimeo Thumbnail"
        [ngSrc]="_thumbnailUrl"
        [width]="_width"
        [height]="_height"
        (load)="loaded()"
      />
    }
    @case ('video') {
      <ng-container [ngTemplateOutlet]="PICTURE"></ng-container>
    }
    @case ('image') {
      <ng-container [ngTemplateOutlet]="PICTURE"></ng-container>
    }
  }

  <ng-container *ngIf="loader">
    <x-loader *ngIf="loading$ | async" [size]="loaderSize"></x-loader>
  </ng-container>
</ng-container>

<ng-template #PICTURE>
  <picture>
    @for (source of imageSources; track source) {
      <source
        [xCloudImage]="_thumbnailUrl"
        [width]="source.width"
        [height]="source.height"
        [media]="source.mediaQuery"
        [crop]="crop"
      />
    }

    <img
      [xCloudImage]="_thumbnailUrl"
      [width]="_width"
      [height]="_height"
      [crop]="crop"
      [attr.loading]="imageLoading"
      (load)="loaded()"
    />
  </picture>
</ng-template>
